/**
 * Regenradar von RainViewer als Kachel-Overlay.
 *
 * RainViewer nennt unter einer Übersichtsadresse die verfügbaren Zeitschritte
 * (Vergangenheit und kurze Vorhersage); jeder Schritt ist ein eigener
 * Kachelsatz. Der Dienst ist frei, ohne Schlüssel und erlaubt Zugriff aus dem
 * Browser (CORS offen) — Kacheln sind ohnehin nur Bilder.
 *
 * https://www.rainviewer.com/api.html
 */

const UEBERSICHT = "https://api.rainviewer.com/public/weather-maps.json";

export interface RadarBild {
  /** Sekunden seit Epoche — der Zeitpunkt der Aufnahme. */
  zeit: number;
  /** Vorlage für die Kachel-URL dieses Zeitschritts. */
  kachelVorlage: string;
  /** Vorhersage statt Messung? */
  vorhersage: boolean;
}

interface RvSchritt {
  time: number;
  path: string;
}

interface RvUebersicht {
  host: string;
  radar?: { past?: RvSchritt[]; nowcast?: RvSchritt[] };
}

/**
 * Die aktuell verfügbaren Radarbilder holen — Messung und Vorhersage, zeitlich
 * geordnet. Farbschema 2 (universal, blau→grün→rot), geglättet und mit
 * Schneekennung.
 */
export async function radarBilderLaden(): Promise<RadarBild[]> {
  const antwort = await fetch(UEBERSICHT, { signal: AbortSignal.timeout(10_000) });
  if (!antwort.ok) throw new Error(`RainViewer: HTTP ${antwort.status}`);
  const daten = (await antwort.json()) as RvUebersicht;

  const bild = (s: RvSchritt, vorhersage: boolean): RadarBild => ({
    zeit: s.time,
    // {z}/{x}/{y} füllt MapLibre; 256 = Kachelgröße, 2 = Farbschema,
    // 1_1 = geglättet + Schneekennung.
    kachelVorlage: `${daten.host}${s.path}/256/{z}/{x}/{y}/2/1_1.png`,
    vorhersage,
  });

  const messung = (daten.radar?.past ?? []).map((s) => bild(s, false));
  const vorher = (daten.radar?.nowcast ?? []).map((s) => bild(s, true));
  return [...messung, ...vorher];
}
